export abstract class ValidatorBase {
    public ErrorMessage:string;

    constructor() {
        this.ErrorMessage='';

    }

    public abstract Execute():boolean;
}